/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_User_Api_Key_Add_Dialog_DescriptionInputs */



/**
* | output |
* | --- |
* | "Create a new API key for programmatic access to the oneAI API." |
*
* @param {Profile_Security_User_Api_Key_Add_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_add_dialog_description = /** @type {((inputs?: Profile_Security_User_Api_Key_Add_Dialog_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_Add_Dialog_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstelle einen neuen API-Schlüssel für den programmatischen Zugriff auf die oneAI-API.")
	return /** @type {LocalizedString} */ ("Create a new API key for programmatic access to the oneAI API.")
});